import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import TermsSummary from "./sections/TermsSummary";
import FullTermsContent from "./sections/FullTermsContent";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
import ClientAgreement from "./sections/ClientAgreement";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <TermsSummary />
      <FullTermsContent />
      <ClientAgreement />
      <ContactCta />
      <Footer />
    </div>;
}